const expressHttpContext = {
  get: () => {},
  set: () => {},
};

export default expressHttpContext;
